export const SETTINGS_TABS = ["profile", "security", "appearance", "credentials"] as const;
export type SettingsTab = (typeof SETTINGS_TABS)[number];
